import { render, staticRenderFns } from "./SpinnerVarients.vue?vue&type=template&id=50c1c54e"
import script from "./SpinnerVarients.vue?vue&type=script&lang=js"
export * from "./SpinnerVarients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports